export const MarinePracticeTypeEnum = {
    SAFETY: {id: 1, code: 'SAFETY', nameRu: "Обучение по технике безопасности, выживанию и охране"},
    MARITIME: {id: 2, code: 'MARITIME', nameRu: "Морская подготовка на базе учебно-тренировочного судна"}
}

